import { equals, isNullOrEmpty, InputElementBase, InputElementBaseProperties } from "@episerver/forms-sdk";
import { useMemo, useEffect } from "react";
import ElementWrapper from "./shared/ElementWrapper";
import { useElement } from "../../hooks/useElement";
import { ValidationMessage } from "./shared";
import FormStatus from "2-core-elements/FormElements/FormStatus";
import { DispatchFunctions } from "3-components/OptimizelyForm/context/dispatchFunctions";

export interface SingleCheckbox extends InputElementBase {
    properties: SingleCheckboxProperties;
}
export interface SingleCheckboxProperties extends InputElementBaseProperties {
    allowMultiSelect: boolean;
    feed: string;
    choiceCaption: string;
    choiceValue: string;
    checkedByDefault?: boolean;
    predefinedValue: string;
}

export interface CheckboxElementBlockProps {
    element: SingleCheckbox
}

export const CheckboxElementBlock = (props: CheckboxElementBlockProps) => {

    const { element } = props;
    const { elementContext, handleChange, handleBlur } = useElement(element);
    const { isVisible, validationResults, value, validatorClasses, extraAttr, elementRef } = elementContext;
    const key = element.key;
    const dispatchFuncs = new DispatchFunctions();

    const isChecked = (!isNullOrEmpty(value) && !isNullOrEmpty(value) && (value).split(',').some((s: string) => equals(s, element.properties.choiceValue)) );

    if ( !element.properties.choiceCaption ) {
        return (
            <FormStatus type="error">
                Please provide caption for <strong>{element.displayName}</strong>
            </FormStatus>
        )
    }

    // set checkbox checked by default if options checkedByDefault is true
    useEffect(() => {
        if ( element.properties.checkedByDefault ) {
            dispatchFuncs.updateValue(key, element.properties.choiceValue);
        }
    },[]);

    return useMemo(()=>(
        <ElementWrapper className={`FormChoice FormSingleChoice ${validatorClasses}`} validationResults={validationResults} isVisible={isVisible} extraAttr={extraAttr}>
            <fieldset aria-describedby={`${element.key}_desc`}>
                <div>
                    <input
                        type="checkbox"
                        id={key}
                        className="FormChoice__Input FormChoice__Input--Checkbox"
                        name={key}
                        value={element.properties.choiceValue}
                        checked={isChecked}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        ref={elementRef}
                        {...extraAttr}
                    />

                    <label htmlFor={key} className="FormChoice__Label">
                        {element.properties.choiceCaption}
                    </label>
                </div>
            </fieldset>
            <ValidationMessage element={element} validationResults={validationResults} />
        </ElementWrapper>

    ),[isVisible, validationResults, value]);

}